import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { StructuredOperationApproveReservationModel } from "../../../model/domain/StructuredOperationApproveReservationModel";
import { AuthService } from "../../../services/auth.service";
import { SnackbarService } from "../../../services/snackbar.service";
import { TicketService } from "../../../services/ticket.service";

@Component({
  selector: "app-operation-structured-reservation-dialog",
  templateUrl: "./operation-structured-reservation-dialog.component.html",
  styleUrls: ["./operation-structured-reservation-dialog.component.css"],
})
export class OperationStructuredReservationDialogComponent {
  ticketId: number;
  groupId: number[];
  reservation: string;
  workflowId: number;
  model: StructuredOperationApproveReservationModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private service: TicketService,
    private authService: AuthService,
    private snackBarService: SnackbarService
  ) {
    this.ticketId = data.ticketId;
    this.groupId = data.groupId;
  }

  saveReservation() {
    this.model = new StructuredOperationApproveReservationModel();
    var modelGroups = this.groupId;
    var auth = this.authService.getAuth();
    var groupRole = auth.groupRoles.find(function (groupRole) {
      return modelGroups.some((x) => x == groupRole.groupId);
    });

    this.model.reservation = this.reservation;
    this.model.ticketId = this.ticketId;
    this.model.groupId = groupRole.groupId;

    this.service.StructuredOperations.approveReservation(this.model).subscribe(
      () => {
        this.snackBarService.open("Boleta atualizada com sucesso.");

        window.location.reload();
      }
    );
  }
}
